import React from 'react';

import { Icon } from '../BaseIcon/Icon';

export type LinkIconProps = {
  type: 'IncreaseLink' | 'CustomLink' | 'UnitLink' | 'StripeLink' | 'AddLink';
};

const entityTypeToIconType = {
  IncreaseLink: 'increaseLink',
  CustomLink: 'customSyncLink',
  UnitLink: 'unitLink',
  StripeLink: 'stripeLink',
  AddLink: 'addLink',
} as const;

export const LinkIcon = ({ type }: LinkIconProps): JSX.Element => (
  <Icon type={entityTypeToIconType[type]} />
);
